// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Menu from 'components/Menu/Menu'
import SearchBar from 'components/Search/SearchBar'
import Link from 'components/Link/Link'
import Logo from 'components/svg/logo/pathfinder-logo.svg'

// Redux:
import { openMenu, closeMenu } from 'actions/site'


class HeaderMobilePrimary extends React.Component {
	constructor( props ) {
		super( props )

		this.handleMenuButtonClick = this.handleMenuButtonClick.bind( this )
	}

	handleMenuButtonClick() {
		const { dispatch, menuIsOpen } = this.props

		if ( menuIsOpen ) {
			document.documentElement.classList.remove( 'with-site-menu-open' )

			dispatch( closeMenu() )
		} else {
			document.documentElement.classList.add( 'with-site-menu-open' )

			dispatch( openMenu() )
		}
	}

	render() {
		const { match, menuItems, menuItemsSecondary } = this.props
		const menuButtonClass = this.props.menuIsOpen ? 'is-active' : ''
		const menuItemsAll = {
			...menuItems,
			...menuItemsSecondary
		}

		return (
			<div className="mobile-nav">
				<div className={ '-menu-button ' + menuButtonClass } type="button" onClick={ this.handleMenuButtonClick }>
					<div className="-hamburger-box">
						<div className="-hamburger-inner"></div>
					</div>
				</div>

				<div className="-logo">
					<Link to="/">
						<Logo />

						<h2>Pathfinders</h2>
					</Link>
				</div>

				<SearchBar />

				<Menu className="mobile-menu-wrap" match={ match } data={ menuItemsAll } isMobile={ true } />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		menuItems: state.site.menuItems,
		menuItemsSecondary: state.site.menuItemsSecondary
	}
}

export default connect( mapStateToProps )( HeaderMobilePrimary )



// WEBPACK FOOTER //
// ./components/HeaderPrimary/HeaderMobilePrimary.jsx